enum ContentType {
  json = "application/json; charset=utf-8",
  formUrlEncoded = "application/x-www-form-urlencoded",
}

export default ContentType;
